<template>
    <div id="buttonConfig">
        <a-modal
            :title="$t('pubGicSet.ButtonConfig')"
            :visible="visible"
            width="50%"
            @cancel="cancelButtonConfig"
            :maskClosable=false
        >
            <template slot="footer">
                <a-button type="primary" @click="saveButtonConfig">{{ $t('publicLang.Save') }}</a-button>
            </template>
            <a-form :form="form">
                <a-row>
                    <a-form-item v-bind="formItemLayout" :label="$t('pubGicSet.ButtonConfigName')" size="small">
                        <a-input
                            size="small"
                            :placeholder="$t('pubGicSet.ButtonConfigName')"
                              v-decorator="[
                                      'btnName',
                                      {
                                        initialValue: editData.btnName,
                                        rules: [{ required: true, message: $t('publicLang.Required') }]
                                      }
                            ]"/>
                    </a-form-item>
                </a-row>
                <a-row>
                    <a-form-item v-bind="formItemLayout" :label="$t('publicLang.Project')">
                        <a-select
                            style="width: 100%"
                            :placeholder="$t('publicLang.Project')"
                            size="small"
                              v-decorator="[
                                  'projectCode',
                                   {
                                    initialValue: editData.projectCode
                                  }
                            ]">
                            <a-select-option v-for="item in projectSelect" :value="item.projectCode">{{item.projectName}}</a-select-option>
                        </a-select>
                    </a-form-item>
                </a-row>
                <a-row>
                    <a-form-item v-bind="formItemLayout" :label="$t('generic.Function')" size="small">
                        <a-select style="width: 100%"  size="small" :placeholder="$t('publicLang.PleaseSelect')" @change="functionActionDataChange"
                              v-decorator="[
                                  'functionCode',
                                  {
                                      initialValue: editData.functionCode,
                                      rules: [{ required: true, message: $t('publicLang.Required') }]
                                  }
                                ]">
                            <a-select-option v-for="item in functionSelect" :value="item.key">{{item.value}}</a-select-option>
                        </a-select>
                    </a-form-item>
                </a-row>
                <a-row>
                    <a-form-item v-bind="formItemLayout" :label="$t('generic.Action')" size="small">
                        <a-select style="width: 100%" size="small" :placeholder="$t('publicLang.PleaseSelect')"  @change="actionChangeData"
                              v-decorator="[
                                  'actionCode',
                                  {
                                      initialValue: editData.actionCode,
                                      rules: [{ required: true, message: $t('publicLang.Required') }]
                                  }
                                ]">
                            <!--@change="handleChange"-->
                            <!--@click="rightActionData(item)"-->
                            <a-select-option v-for="item in actionList" :value="item.key">{{item.value}}</a-select-option>
                        </a-select>
                    </a-form-item>
                </a-row>
                <a-row>
                    <a-form-item v-bind="formItemLayout" :label="$t('pubGicSet.BePrint')" size="small">
                        <a-switch
                            size="small"
                            v-decorator="[
                              'bePrint',
                              {
                                initialValue: editData.bePrint,
                                valuePropName: 'checked'
                              }
                            ]"
                        />
                    </a-form-item>
                </a-row>


                <a-row>
                    <a-form-item v-bind="formItemLayout" :label="$t('pubGicSet.ActionValue')" size="small">
                        <a-col  style="height: 25vh;overflow: hidden;overflow-y: auto;border: 1px solid #efefef" >
                            <draggable tag="ul" :list="rightlist" class="list-group" handle=".handle" style="">
                                <li class="handle dragLi" v-for="(item, idx) in rightlist" :key="item.key">
                                    <span class="fl">{{ item.value }} </span>
                                    <span class="fr"><a-switch  v-model="item.switch"/></span>
                                </li>
                            </draggable>
                            <p v-if="rightlist.length == 0" style="font-size: 12px; color: red;line-height: 19vh;text-align: center;">No record found !</p>
                        </a-col>
                    </a-form-item>
                </a-row>
            </a-form>
        </a-modal>
    </div>
</template>
<script>
    import draggable from "vuedraggable";
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    export default{
        components: {
            draggable
        },
        data(){
            return{
                rightlist: [],
                actionList: [],
                visible: false,
                form: this.$form.createForm(this),
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
                projectSelect: [],
                functionSelect: [],
                editData: {},
                editUid: undefined,
                subCheckedSelect: []
            }
        },
        computed: {
            draggingInfo() {
                return this.dragging ? "under drag" : "";
            }
        },
        methods:{
            show(id){
                this.visible = true
                this.initData(id)
                this.editUid = id
            },
            cancelButtonConfig(){
                this.visible = false
                this.form.resetFields();
                this.editData = {}
                this.rightlist = []
                this.actionList = []
            },
            initData(id){
               ajax.get(api.GENERICPROJECTLIST).then(res=>{
                   this.projectSelect = res.data
               })
                ajax.get(api.GENERICPRINTNODEFUNCTION).then(res=>{
                    this.functionSelect = res.data
                })
                if(id != undefined){
                    ajax.get(api.GENERICPRINTNODEBTNCONFIG,{uid: id}).then(res=>{
                        this.editData = res.data
                        this.actionData(this.editData.functionCode)
                        this.subCheckedSelect = this.editData.subActionCodeList
                        this.actionChangeData(this.editData.actionCode)
                    })
                }
            },
            functionActionDataChange(val){
                this.rightlist = []
                this.actionData(val)
            },
            actionData(val){
                ajax.get(api.GERNERICPRINTNODEACTION,{function: val}).then(res=>{
                    this.actionList = res.data
                })
            },
            actionChangeData(val){;
                ajax.get(api.GERNERICPRINTNODEACTION,{action: val}).then(res=>{
                    this.rightlist = res.data
                    if(this.subCheckedSelect.length > 0) {
                        let arr = this.rightlist
                        let subArr =  this.subCheckedSelect
                        for(let i in arr) {
                            if(subArr.indexOf(arr[i].key) != -1) {
                                arr[i].switch = true
                            }
                        }
                    }
                })
            },
            saveButtonConfig(){
                this.form.validateFields((err,value)=>{
                    if(!err){
                        let rightlist = []
                        for(let i in this.rightlist){
                            if(this.rightlist[i].switch){
                                rightlist.push(this.rightlist[i].key)
                            }
                        }
                        let params = {
                            actionCode: value.actionCode,
                            btnName: value.btnName,
                            functionCode: value.functionCode,
                            projectCode: value.projectCode,
                            subActionCodeList: rightlist,
                            bePrint: value.bePrint
                        }
                        if(this.editUid != ''){
                            params.uid = this.editUid
                        }
                        ajax.post(api.GENERICPRINTNODEBTNCONFIG,params).then(res=>{
                            if(res.code == 200){
                                this.visible = false
                                this.form.resetFields();
                                this.rightlist = []
                                this.actionList = []
                                this.$emit('btnConfigemit','init')
                            }else{
                                this.$customMessage.error(res.msg);
                            }
                        })
                    }

                })
            }
        }
    }
</script>
<style lang="less">
.dragLi{
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
    line-height: 30px;
    height: 30px;
    cursor: pointer;
    border-bottom: 1px solid #efefef;
    padding: 0 4px;
    overflow: hidden;
}
</style>